(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-banner-custom"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const details = document.querySelector('[data-collection-description-accordion]');
    if (!details) return;

    const syncDescriptionVisibility = () => {
      document.documentElement.classList.toggle(
        'collection-description-expanded-top',
        details.open
      );
    };

    details.addEventListener('toggle', syncDescriptionVisibility);
    syncDescriptionVisibility();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener('DOMContentLoaded', () => {
      const card = document.getElementById(url.hash.slice(1));
      if (card) {
        card.scrollIntoView({behavior: 'instant'});
      }
    }, {once: true});
  }

  } catch(e) { console.error(e); }
})();
})();
